export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      properties: 'Nos biens',
      hotels: 'Hôtels',
      immeubles: 'Immeubles',
      exception: "Biens d'exception",
      liquidation: 'Liquidation judiciaire',
      expertise: 'Expertises',
      about: 'À propos',
      contact: 'Contact',
    },
    hero: {
      eyebrow: 'BIENS · PERSONNES · OPPORTUNITÉS',
      title: 'DES LIEUX POUR DEMAIN',
      subtitle: 'TRANSACTION · CONSEIL · INVESTISSEMENT · VALORISATION',
      quote: "L'immobilier comme moteur de nouveaux horizons.",
      regions: 'FRANCE · SUISSE · INTERNATIONAL',
      cta: 'Découvrir nos biens',
      cta2: 'Nous contacter',
    },
    intro: {
      eyebrow: 'L’AGENCE',
      title: 'Une signature immobilière entre la France et la Suisse',
      text: "STARKKE Immobilier accompagne investisseurs, institutions et grandes familles dans l’acquisition, la cession et la valorisation d’actifs d’exception. Hôtels, immeubles et demeures rares : nous cultivons la discrétion, l’exigence et la vision long terme.",
      stat1: "actifs",
      stat2: 'pays',
      stat3: 'années d’expertise',
    },
    sections: {
      eyebrow: 'NOS EXPERTISES SECTORIELLES',
      title: 'Cinq univers, une même exigence',
      explore: 'Explorer',
    },
    featured: {
      eyebrow: 'SÉLECTION',
      title: 'Biens à la une',
      viewAll: 'Voir tous les biens',
    },
    values: {
      eyebrow: 'NOTRE APPROCHE',
      title: 'Ce qui nous distingue',
      v1t: 'Discrétion absolue',
      v1d: 'Des mandats confidentiels traités avec la plus grande réserve.',
      v2t: 'Ancrage franco-suisse',
      v2d: 'Une connaissance fine des marchés de part et d’autre de la frontière.',
      v3t: 'Vision d’investisseur',
      v3d: 'Chaque bien analysé comme un actif, pour créer de la valeur durable.',
      v4t: 'Réseau international',
      v4d: 'Un carnet d’adresses ouvert sur les grandes places européennes.',
    },
    cta: {
      title: 'Un projet, un actif, une ambition ?',
      text: 'Échangeons en toute confidentialité sur vos objectifs immobiliers.',
      button: 'Prendre rendez-vous',
    },
    properties: {
      title: 'Nos biens',
      subtitle: 'Une sélection d’actifs rares en France, en Suisse et à l’international.',
      filterAll: 'Tous',
      country: 'Pays',
      countryAll: 'Tous les pays',
      results: 'bien(s)',
      empty: 'Aucun bien ne correspond à votre recherche.',
      advanced: 'Filtres', priceRange: 'Prix (M€)', surfaceRange: 'Surface (m²)', min: 'Min', max: 'Max', reset: 'Réinitialiser',
    },
    detail: {
      back: 'Retour aux biens',
      overview: 'Présentation',
      features: 'Caractéristiques',
      surface: 'Surface',
      price: 'Prix',
      reference: 'Référence',
      location: 'Localisation',
      interested: 'Ce bien vous intéresse ?',
      interestedText: 'Contactez-nous pour recevoir le dossier complet en toute confidentialité.',
      contactBtn: 'Demander le dossier',
      similar: 'Biens similaires',
      onRequest: 'Prix sur demande',
    },
    expertise: {
      title: 'Nos expertises',
      subtitle: 'Un accompagnement global, du conseil stratégique à la valorisation.',
      e1t: 'Transaction',
      e1d: 'Acquisition et cession d’actifs immobiliers de prestige, en toute confidentialité.',
      e2t: 'Conseil',
      e2d: 'Stratégie patrimoniale, arbitrage et structuration de vos investissements.',
      e3t: 'Investissement',
      e3d: 'Identification d’opportunités à fort potentiel, en direct ou en club deal.',
      e4t: 'Valorisation',
      e4d: 'Repositionnement, restructuration et création de valeur sur vos actifs.',
      processTitle: 'Notre méthode',
      p1t: 'Écoute',
      p1d: 'Comprendre vos objectifs patrimoniaux et vos contraintes.',
      p2t: 'Analyse',
      p2d: 'Étude approfondie du marché et des actifs cibles.',
      p3t: 'Exécution',
      p3d: 'Négociation et sécurisation de l’opération.',
      p4t: 'Suivi',
      p4d: 'Accompagnement dans la durée et création de valeur.',
    },
    about: {
      title: 'STARKKE Immobilier',
      lead: 'Des lieux pour demain.',
      p1: "Née de la conviction que l’immobilier est un moteur de transformation, STARKKE Immobilier accompagne une clientèle exigeante entre la France et la Suisse. Nous intervenons sur les actifs les plus rares — hôtels, immeubles, demeures d’exception — avec une approche d’investisseur et une culture du résultat.",
      p2: "Notre métier ne se limite pas à la transaction : nous concevons des stratégies, révélons le potentiel des actifs et créons de la valeur durable. Discrétion, exigence et vision long terme guident chacun de nos mandats.",
      missionTitle: 'Notre raison d’être',
      mission: 'Faire de chaque bien un point de départ vers de nouveaux horizons.',
    },
    contact: {
      title: 'Contact',
      subtitle: 'Échangeons sur votre projet en toute confidentialité.',
      name: 'Nom complet',
      email: 'Email',
      phone: 'Téléphone',
      subject: 'Sujet',
      message: 'Votre message',
      send: 'Envoyer',
      sent: 'Merci, votre message a bien été envoyé. Nous vous recontactons rapidement.',
      infoTitle: 'Nous joindre',
      hours: 'Sur rendez-vous — France & Suisse',
    },
    footer: {
      tagline: 'Des lieux pour demain.',
      explore: 'Explorer',
      expertises: 'Expertises',
      contact: 'Contact',
      rights: 'Tous droits réservés.',
      legal: 'Mentions légales',
      privacy: 'Confidentialité',
    },
  },
  en: {
    nav: {
      home: 'Home',
      properties: 'Properties',
      hotels: 'Hotels',
      immeubles: 'Buildings',
      exception: 'Exceptional',
      liquidation: 'Liquidation',
      expertise: 'Expertise',
      about: 'About',
      contact: 'Contact',
    },
    hero: {
      eyebrow: 'ASSETS · PEOPLE · OPPORTUNITIES',
      title: 'PLACES FOR TOMORROW',
      subtitle: 'TRANSACTION · ADVISORY · INVESTMENT · VALUE CREATION',
      quote: 'Real estate as an engine for new horizons.',
      regions: 'FRANCE · SWITZERLAND · INTERNATIONAL',
      cta: 'Discover our properties',
      cta2: 'Contact us',
    },
    intro: {
      eyebrow: 'THE AGENCY',
      title: 'A real estate signature between France and Switzerland',
      text: 'STARKKE Immobilier advises investors, institutions and prominent families on the acquisition, disposal and enhancement of exceptional assets. Hotels, buildings and rare estates: we cultivate discretion, rigor and a long-term vision.',
      stat1: 'assets advised',
      stat2: 'countries',
      stat3: 'years of expertise',
    },
    sections: {
      eyebrow: 'OUR SECTOR EXPERTISE',
      title: 'Five worlds, one standard',
      explore: 'Explore',
    },
    featured: {
      eyebrow: 'SELECTION',
      title: 'Featured properties',
      viewAll: 'View all properties',
    },
    values: {
      eyebrow: 'OUR APPROACH',
      title: 'What sets us apart',
      v1t: 'Absolute discretion',
      v1d: 'Confidential mandates handled with the utmost reserve.',
      v2t: 'Franco-Swiss roots',
      v2d: 'A refined knowledge of markets on both sides of the border.',
      v3t: 'Investor mindset',
      v3d: 'Every property analyzed as an asset, to create lasting value.',
      v4t: 'International network',
      v4d: 'A directory open to Europe’s major markets.',
    },
    cta: {
      title: 'A project, an asset, an ambition?',
      text: 'Let’s discuss your real estate goals in full confidentiality.',
      button: 'Book a meeting',
    },
    properties: {
      title: 'Our properties',
      subtitle: 'A selection of rare assets in France, Switzerland and internationally.',
      filterAll: 'All',
      country: 'Country',
      countryAll: 'All countries',
      results: 'result(s)',
      empty: 'No property matches your search.',
      advanced: 'Filters', priceRange: 'Price (€M)', surfaceRange: 'Surface (sqm)', min: 'Min', max: 'Max', reset: 'Reset',
    },
    detail: {
      back: 'Back to properties',
      overview: 'Overview',
      features: 'Features',
      surface: 'Surface',
      price: 'Price',
      reference: 'Reference',
      location: 'Location',
      interested: 'Interested in this property?',
      interestedText: 'Contact us to receive the full file in complete confidentiality.',
      contactBtn: 'Request the file',
      similar: 'Similar properties',
      onRequest: 'Price on request',
    },
    expertise: {
      title: 'Our expertise',
      subtitle: 'End-to-end support, from strategic advisory to value creation.',
      e1t: 'Transaction',
      e1d: 'Acquisition and disposal of prestige real estate assets, in full confidentiality.',
      e2t: 'Advisory',
      e2d: 'Wealth strategy, arbitrage and structuring of your investments.',
      e3t: 'Investment',
      e3d: 'Identifying high-potential opportunities, directly or via club deals.',
      e4t: 'Value creation',
      e4d: 'Repositioning, restructuring and value creation on your assets.',
      processTitle: 'Our method',
      p1t: 'Listen',
      p1d: 'Understand your wealth objectives and constraints.',
      p2t: 'Analyze',
      p2d: 'In-depth study of the market and target assets.',
      p3t: 'Execute',
      p3d: 'Negotiation and securing of the transaction.',
      p4t: 'Follow-up',
      p4d: 'Long-term support and value creation.',
    },
    about: {
      title: 'STARKKE Immobilier',
      lead: 'Places for tomorrow.',
      p1: 'Born from the conviction that real estate is an engine of transformation, STARKKE Immobilier serves a demanding clientele between France and Switzerland. We operate on the rarest assets — hotels, buildings, exceptional estates — with an investor’s approach and a results-driven culture.',
      p2: 'Our work goes beyond transactions: we design strategies, reveal the potential of assets and create lasting value. Discretion, rigor and a long-term vision guide each of our mandates.',
      missionTitle: 'Our purpose',
      mission: 'Turning every property into a starting point toward new horizons.',
    },
    contact: {
      title: 'Contact',
      subtitle: 'Let’s discuss your project in full confidentiality.',
      name: 'Full name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Your message',
      send: 'Send',
      sent: 'Thank you, your message has been sent. We will get back to you shortly.',
      infoTitle: 'Reach us',
      hours: 'By appointment — France & Switzerland',
    },
    footer: {
      tagline: 'Places for tomorrow.',
      explore: 'Explore',
      expertises: 'Expertise',
      contact: 'Contact',
      rights: 'All rights reserved.',
      legal: 'Legal notice',
      privacy: 'Privacy',
    },
  },
  es: {
    nav: { home: 'Inicio', properties: 'Propiedades', hotels: 'Hoteles', immeubles: 'Edificios', exception: 'Excepcionales', liquidation: 'Liquidación', expertise: 'Servicios', about: 'Nosotros', contact: 'Contacto' },
    hero: {
      eyebrow: 'ACTIVOS · PERSONAS · OPORTUNIDADES',
      title: 'LUGARES PARA EL MAÑANA',
      subtitle: 'TRANSACCIÓN · ASESORAMIENTO · INVERSIÓN · VALORIZACIÓN',
      quote: 'El inmobiliario como motor de nuevos horizontes.',
      regions: 'FRANCIA · SUIZA · INTERNACIONAL',
      cta: 'Descubrir nuestras propiedades', cta2: 'Contáctenos',
    },
    intro: {
      eyebrow: 'LA AGENCIA',
      title: 'Una firma inmobiliaria entre Francia y Suiza',
      text: 'STARKKE Immobilier acompaña a inversores, instituciones y grandes familias en la adquisición, venta y valorización de activos excepcionales. Hoteles, edificios y residencias singulares: cultivamos la discreción, la exigencia y la visión a largo plazo.',
      stat1: 'activos asesorados', stat2: 'países', stat3: 'años de experiencia',
    },
    sections: { eyebrow: 'NUESTRA EXPERIENCIA SECTORIAL', title: 'Cinco universos, una misma exigencia', explore: 'Explorar' },
    featured: { eyebrow: 'SELECCIÓN', title: 'Propiedades destacadas', viewAll: 'Ver todas las propiedades' },
    values: {
      eyebrow: 'NUESTRO ENFOQUE', title: 'Lo que nos distingue',
      v1t: 'Discreción absoluta', v1d: 'Mandatos confidenciales tratados con la máxima reserva.',
      v2t: 'Raíces franco-suizas', v2d: 'Un conocimiento profundo de los mercados a ambos lados de la frontera.',
      v3t: 'Visión de inversor', v3d: 'Cada propiedad analizada como un activo, para crear valor duradero.',
      v4t: 'Red internacional', v4d: 'Una agenda abierta a las grandes plazas europeas.',
    },
    cta: { title: '¿Un proyecto, un activo, una ambición?', text: 'Hablemos de sus objetivos inmobiliarios con total confidencialidad.', button: 'Solicitar una cita' },
    properties: {
      title: 'Nuestras propiedades', subtitle: 'Una selección de activos singulares en Francia, Suiza e internacionalmente.',
      filterAll: 'Todas', country: 'País', countryAll: 'Todos los países', results: 'resultado(s)', empty: 'Ninguna propiedad coincide con su búsqueda.',
      advanced: 'Filtros', priceRange: 'Precio (M€)', surfaceRange: 'Superficie (m²)', min: 'Mín', max: 'Máx', reset: 'Restablecer',
    },
    detail: {
      back: 'Volver a las propiedades', overview: 'Presentación', features: 'Características', surface: 'Superficie', price: 'Precio', reference: 'Referencia', location: 'Ubicación',
      interested: '¿Le interesa esta propiedad?', interestedText: 'Contáctenos para recibir el expediente completo con total confidencialidad.', contactBtn: 'Solicitar el expediente', similar: 'Propiedades similares', onRequest: 'Precio a consultar',
    },
    expertise: {
      title: 'Nuestros servicios', subtitle: 'Un acompañamiento integral, del asesoramiento estratégico a la valorización.',
      e1t: 'Transacción', e1d: 'Adquisición y venta de activos inmobiliarios de prestigio, con total confidencialidad.',
      e2t: 'Asesoramiento', e2d: 'Estrategia patrimonial, arbitraje y estructuración de sus inversiones.',
      e3t: 'Inversión', e3d: 'Identificación de oportunidades de alto potencial, directas o en club deal.',
      e4t: 'Valorización', e4d: 'Reposicionamiento, reestructuración y creación de valor sobre sus activos.',
      processTitle: 'Nuestro método', p1t: 'Escuchar', p1d: 'Comprender sus objetivos patrimoniales y sus limitaciones.',
      p2t: 'Analizar', p2d: 'Estudio en profundidad del mercado y los activos objetivo.', p3t: 'Ejecutar', p3d: 'Negociación y aseguramiento de la operación.', p4t: 'Seguimiento', p4d: 'Acompañamiento en el tiempo y creación de valor.',
    },
    about: {
      title: 'STARKKE Immobilier', lead: 'Lugares para el mañana.',
      p1: 'Nacida de la convicción de que el inmobiliario es un motor de transformación, STARKKE Immobilier acompaña a una clientela exigente entre Francia y Suiza. Intervenimos sobre los activos más singulares —hoteles, edificios, residencias excepcionales— con una visión de inversor y una cultura del resultado.',
      p2: 'Nuestro oficio no se limita a la transacción: diseñamos estrategias, revelamos el potencial de los activos y creamos valor duradero. Discreción, exigencia y visión a largo plazo guían cada uno de nuestros mandatos.',
      missionTitle: 'Nuestra razón de ser', mission: 'Hacer de cada propiedad un punto de partida hacia nuevos horizontes.',
    },
    contact: {
      title: 'Contacto', subtitle: 'Hablemos de su proyecto con total confidencialidad.', name: 'Nombre completo', email: 'Email', phone: 'Teléfono', subject: 'Asunto', message: 'Su mensaje', send: 'Enviar',
      sent: 'Gracias, su mensaje ha sido enviado. Le contactaremos en breve.', infoTitle: 'Cómo contactarnos', hours: 'Con cita previa — Francia y Suiza',
    },
    footer: { tagline: 'Lugares para el mañana.', explore: 'Explorar', expertises: 'Servicios', contact: 'Contacto', rights: 'Todos los derechos reservados.', legal: 'Aviso legal', privacy: 'Privacidad' },
  },
  de: {
    nav: { home: 'Start', properties: 'Objekte', hotels: 'Hotels', immeubles: 'Gebäude', exception: 'Aussergewöhnlich', liquidation: 'Verwertung', expertise: 'Leistungen', about: 'Über uns', contact: 'Kontakt' },
    hero: {
      eyebrow: 'OBJEKTE · MENSCHEN · CHANCEN',
      title: 'ORTE FÜR MORGEN',
      subtitle: 'TRANSAKTION · BERATUNG · INVESTITION · WERTSTEIGERUNG',
      quote: 'Immobilien als Motor für neue Horizonte.',
      regions: 'FRANKREICH · SCHWEIZ · INTERNATIONAL',
      cta: 'Objekte entdecken', cta2: 'Kontakt aufnehmen',
    },
    intro: {
      eyebrow: 'DIE AGENTUR',
      title: 'Eine Immobilien-Signatur zwischen Frankreich und der Schweiz',
      text: 'STARKKE Immobilier begleitet Investoren, Institutionen und grosse Familien beim Erwerb, Verkauf und der Wertsteigerung aussergewöhnlicher Objekte. Hotels, Gebäude und seltene Anwesen: Wir pflegen Diskretion, Anspruch und eine langfristige Vision.',
      stat1: 'beratene Objekte', stat2: 'Länder', stat3: 'Jahre Erfahrung',
    },
    sections: { eyebrow: 'UNSERE SEKTORKOMPETENZ', title: 'Fünf Welten, ein Anspruch', explore: 'Entdecken' },
    featured: { eyebrow: 'AUSWAHL', title: 'Ausgewählte Objekte', viewAll: 'Alle Objekte ansehen' },
    values: {
      eyebrow: 'UNSER ANSATZ', title: 'Was uns auszeichnet',
      v1t: 'Absolute Diskretion', v1d: 'Vertrauliche Mandate mit grösster Zurückhaltung behandelt.',
      v2t: 'Deutsch-französische Verankerung', v2d: 'Fundierte Marktkenntnis auf beiden Seiten der Grenze.',
      v3t: 'Investoren-Denken', v3d: 'Jedes Objekt als Anlage analysiert, für nachhaltigen Wert.',
      v4t: 'Internationales Netzwerk', v4d: 'Ein Adressbuch, offen für Europas grosse Standorte.',
    },
    cta: { title: 'Ein Projekt, ein Objekt, eine Ambition?', text: 'Sprechen wir vertraulich über Ihre Immobilienziele.', button: 'Termin vereinbaren' },
    properties: {
      title: 'Unsere Objekte', subtitle: 'Eine Auswahl seltener Objekte in Frankreich, der Schweiz und international.',
      filterAll: 'Alle', country: 'Land', countryAll: 'Alle Länder', results: 'Ergebnis(se)', empty: 'Kein Objekt entspricht Ihrer Suche.',
      advanced: 'Filter', priceRange: 'Preis (Mio. €)', surfaceRange: 'Fläche (m²)', min: 'Min', max: 'Max', reset: 'Zurücksetzen',
    },
    detail: {
      back: 'Zurück zu den Objekten', overview: 'Präsentation', features: 'Merkmale', surface: 'Fläche', price: 'Preis', reference: 'Referenz', location: 'Lage',
      interested: 'Interesse an diesem Objekt?', interestedText: 'Kontaktieren Sie uns, um die vollständigen Unterlagen vertraulich zu erhalten.', contactBtn: 'Unterlagen anfordern', similar: 'Ähnliche Objekte', onRequest: 'Preis auf Anfrage',
    },
    expertise: {
      title: 'Unsere Leistungen', subtitle: 'Ganzheitliche Begleitung, von der strategischen Beratung bis zur Wertsteigerung.',
      e1t: 'Transaktion', e1d: 'Erwerb und Verkauf von Prestige-Immobilien, absolut vertraulich.',
      e2t: 'Beratung', e2d: 'Vermögensstrategie, Arbitrage und Strukturierung Ihrer Investitionen.',
      e3t: 'Investition', e3d: 'Identifikation von Chancen mit hohem Potenzial, direkt oder als Club Deal.',
      e4t: 'Wertsteigerung', e4d: 'Repositionierung, Umstrukturierung und Wertschöpfung Ihrer Objekte.',
      processTitle: 'Unsere Methode', p1t: 'Zuhören', p1d: 'Ihre Vermögensziele und Rahmenbedingungen verstehen.',
      p2t: 'Analysieren', p2d: 'Eingehende Studie des Marktes und der Zielobjekte.', p3t: 'Umsetzen', p3d: 'Verhandlung und Absicherung der Transaktion.', p4t: 'Begleitung', p4d: 'Langfristige Betreuung und Wertschöpfung.',
    },
    about: {
      title: 'STARKKE Immobilier', lead: 'Orte für morgen.',
      p1: 'Aus der Überzeugung entstanden, dass Immobilien ein Motor des Wandels sind, begleitet STARKKE Immobilier eine anspruchsvolle Kundschaft zwischen Frankreich und der Schweiz. Wir agieren bei den seltensten Objekten — Hotels, Gebäude, aussergewöhnliche Anwesen — mit dem Denken eines Investors und einer ergebnisorientierten Kultur.',
      p2: 'Unsere Arbeit geht über die Transaktion hinaus: Wir entwerfen Strategien, heben das Potenzial von Objekten und schaffen nachhaltigen Wert. Diskretion, Anspruch und Weitblick leiten jedes unserer Mandate.',
      missionTitle: 'Unser Anliegen', mission: 'Aus jedem Objekt einen Ausgangspunkt zu neuen Horizonten machen.',
    },
    contact: {
      title: 'Kontakt', subtitle: 'Sprechen wir vertraulich über Ihr Projekt.', name: 'Vollständiger Name', email: 'E-Mail', phone: 'Telefon', subject: 'Betreff', message: 'Ihre Nachricht', send: 'Senden',
      sent: 'Vielen Dank, Ihre Nachricht wurde gesendet. Wir melden uns in Kürze.', infoTitle: 'So erreichen Sie uns', hours: 'Nach Vereinbarung — Frankreich & Schweiz',
    },
    footer: { tagline: 'Orte für morgen.', explore: 'Entdecken', expertises: 'Leistungen', contact: 'Kontakt', rights: 'Alle Rechte vorbehalten.', legal: 'Impressum', privacy: 'Datenschutz' },
  },
  zh: {
    nav: { home: '首页', properties: '房源', hotels: '酒店', immeubles: '楼宇', exception: '顶级物业', liquidation: '司法清算', expertise: '专业服务', about: '关于我们', contact: '联系我们' },
    hero: {
      eyebrow: '资产 · 人脉 · 机遇',
      title: '成就明日之所',
      subtitle: '交易 · 咨询 · 投资 · 增值',
      quote: '以地产驱动崭新视野。',
      regions: '法国 · 瑞士 · 国际',
      cta: '浏览房源', cta2: '联系我们',
    },
    intro: {
      eyebrow: '关于本行',
      title: '往返法国与瑞士的地产典范',
      text: 'STARKKE Immobilier 为投资者、机构及名门家族提供卓越资产的收购、出售与增值服务。酒店、楼宇与稀有名邸——我们秉持审慎、严谨与长远视野。',
      stat1: '受托管理资产', stat2: '国家', stat3: '年专业经验',
    },
    sections: { eyebrow: '我们的行业专长', title: '五大领域，同一标准', explore: '探索' },
    featured: { eyebrow: '臻选', title: '精选房源', viewAll: '查看全部房源' },
    values: {
      eyebrow: '我们的理念', title: '与众不同之处',
      v1t: '绝对审慎', v1d: '以最高保密标准处理每一项委托。',
      v2t: '法瑞根基', v2d: '深谙法瑞两地市场的精细洞察。',
      v3t: '投资者视角', v3d: '将每处物业视为资产，创造持久价值。',
      v4t: '国际网络', v4d: '通达欧洲各大重镇的人脉资源。',
    },
    cta: { title: '一个项目、一处资产、一份雄心？', text: '让我们以完全保密的方式探讨您的地产目标。', button: '预约洽谈' },
    properties: {
      title: '我们的房源', subtitle: '精选法国、瑞士及国际的稀有资产。',
      filterAll: '全部', country: '国家', countryAll: '所有国家', results: '个结果', empty: '没有符合您搜索条件的房源。',
      advanced: '筛选', priceRange: '价格（百万€）', surfaceRange: '面积（㎡）', min: '最低', max: '最高', reset: '重置',
    },
    detail: {
      back: '返回房源', overview: '物业介绍', features: '物业特色', surface: '面积', price: '价格', reference: '编号', location: '位置',
      interested: '对此物业感兴趣？', interestedText: '请联系我们，以完全保密方式获取完整资料。', contactBtn: '索取资料', similar: '相似房源', onRequest: '价格面议',
    },
    expertise: {
      title: '我们的专业服务', subtitle: '从战略咨询到价值创造的全程陪伴。',
      e1t: '交易', e1d: '以完全保密的方式收购与出售尊贵地产资产。',
      e2t: '咨询', e2d: '财富战略、资产调配及投资架构设计。',
      e3t: '投资', e3d: '甄别高潜力机遇，直接投资或俱乐部交易。',
      e4t: '增值', e4d: '对您的资产进行重新定位、重组与价值创造。',
      processTitle: '我们的方法', p1t: '倾听', p1d: '了解您的财富目标与约束条件。',
      p2t: '分析', p2d: '对市场与目标资产进行深入研究。', p3t: '执行', p3d: '谈判并确保交易顺利完成。', p4t: '跟进', p4d: '长期陪伴与持续创造价值。',
    },
    about: {
      title: 'STARKKE Immobilier', lead: '成就明日之所。',
      p1: '源于「地产是变革之引擎」的信念，STARKKE Immobilier 服务往返法国与瑞士的高端客群。我们以投资者视角与结果导向的文化，专注于最稀有的资产——酒店、楼宇与卓越名邸。',
      p2: '我们的工作不止于交易：我们制定战略、发掘资产潜力并创造持久价值。审慎、严谨与长远视野贯穿每一项委托。',
      missionTitle: '我们的使命', mission: '让每一处物业成为通往崭新视野的起点。',
    },
    contact: {
      title: '联系我们', subtitle: '让我们以完全保密的方式探讨您的项目。', name: '姓名', email: '电子邮箱', phone: '电话', subject: '主题', message: '您的留言', send: '发送',
      sent: '感谢您，您的留言已发送。我们将尽快与您联系。', infoTitle: '联系方式', hours: '预约制 — 法国及瑞士',
    },
    footer: { tagline: '成就明日之所。', explore: '探索', expertises: '专业服务', contact: '联系我们', rights: '版权所有。', legal: '法律声明', privacy: '隐私政策' },
  },
};
